import { computed, reactive, ref } from 'vue'
import { useStore } from 'vuex'
import readed from '@/assets/img/chat/readed.png'
import unread from '@/assets/img/chat/unread.png'
import { getFinishPrecheck } from '@/api/chat'
import { Modal } from 'ant-design-vue'
import EventBus from '@/utils/EventBus.js'

export default function useReadStatus(activeKey) {
  const store = useStore()
  const curGroupInfo = computed(() => store.state.workOrder.workOrderGroupInfo)
  const { assistantInfos, doctorInfo, patientInfo, doctorAssistantInfos } = curGroupInfo.value
  //未读数量
  const defineUnReadNum = {
    guideConsultGroupId: 0,
    groupId: 0,
    privateId: 0,
    doctorDaGroupId: 0
  }
  const unReadNum = reactive({ ...defineUnReadNum })
  //所有群聊消息集合
  const allGroupMsgList = ref(store.state.chat.msgList.group || {})
  const handleAckReadStatus = ctxMsg => {
    const { readRoles = [], msgRecipients, bySelf } = ctxMsg
    const readCallback = {
      type: 'img',
      res: '',
      num: '' // 兼容未读数量
    }

    // 不再区分群聊类型
    if (bySelf) {
      // 自己发的消息
      if (readRoles.length && readRoles.length === msgRecipients.length - 1) {
        readCallback.res = readed
      } else if (readRoles.length === 0) {
        readCallback.res = unread
        readCallback.num = 0
      } else {
        readCallback.type = 'count'
        readCallback.res = readRoles.length
      }
    } else {
      // 别人发的消息 不考虑全部已读状态
      if (readRoles.length === 0) {
        readCallback.res = unread
        readCallback.num = 0
      } else {
        readCallback.type = 'count'
        readCallback.res = readRoles.length
      }
    }

    return readCallback
  }

  const hadnleReadRoles = ctxMsg => {
    const { readRoles = [] } = ctxMsg
    const res = []
    const curPrivateMembers = computed(() => store.state.workOrder.privateGroupMembers)
    const rolesSummary = [
      ...assistantInfos,
      doctorInfo,
      patientInfo,
      ...doctorAssistantInfos,
      ...curPrivateMembers.value
    ]
    if (readRoles.length) {
      // const readMembers = readRoles.concat(extraReaders.map(item => item.emUserId)) 追读人员不显示
      readRoles.forEach(item => {
        const temp = rolesSummary.find(it => {
          return it.userId === item
        })
        if (temp) {
          let roles = ''
          const first = temp.userId ? temp.userId.substr(0, 1) : ''
          if (first === 'p') {
            roles = '患者'
          } else if (first === 'a') {
            roles = 'BD'
          } else if (first === 'z') {
            roles = '医生助手'
          } else if (first === 'h') {
            roles = '合作医助'
          } else {
            roles = '医生'
          }
          res.push(`${roles}-${temp.username}`)
        }
      })
    }
    return res
  }
  //角标设置
  const computedUnRead = key => {
    return activeKey.value === key ? 0 : getUnread(key)
  }
  //未读角标统计
  const getUnread = groupId => {
    const chatList = allGroupMsgList.value[groupId] || []
    let unreadMsg = 0
    if (chatList.length > 0) {
      chatList
        // AI 的消息不进行提醒
        .filter(v => v.customEvent !== '50800')
        .map(v => {
          // 23009-单病种随访问卷 消息免打扰
          if (v.status === 'unread' && v.customEvent !== '23009') {
            unreadMsg++
          }
        })
    }
    return unreadMsg
  }
  //处理完成工单提醒文案
  const generateMessages = data => {
    const groupTypeEnum = ['问诊会话', '医生团队', '患者私聊', '导诊咨询', '医生私聊']
    // 按照指定的顺序进行排序
    const order = [3, 0, 2, 4, 1] // 排序的顺序
    // 排序数据，确保 groupType 按照 order 数组中的顺序排列
    const sortedData = order
      .map(type => data.find(item => item.groupType === type))
      .filter(item => item !== undefined && item !== null)
    // 获取排序后的 groupType 文本并拼接成一个字符串
    const groupTypes = sortedData.map(item => groupTypeEnum[item.groupType])
    // 拼接最终的消息
    return `系统监测【${groupTypes.join('】【')}】，有其他人员发送话术您未读，请去查看处理。`
  }
  // 提示未读消息
  const showWarning = grouoInfo => {
    const { groupId } = grouoInfo[0]
    Modal.warning({
      title: '提示',
      content: generateMessages(grouoInfo),
      okText: '知道了',
      onOk() {
        EventBus.emit('SET_ACTIVE_TABS_KEY', groupId)
      }
    })
  }
  // 获取缓存中的未读消息群组数据、缓存时间和提示信息
  const getCacheData = () => {
    const cache = JSON.parse(sessionStorage.getItem('UNREAD_GROUP_CACHE')) || {}
    return cache
  }
  // 设置缓存中的未读消息群组数据、缓存时间和提示信息
  const setCacheData = (time, groups) => {
    const cache = { time, groups }
    sessionStorage.setItem('UNREAD_GROUP_CACHE', JSON.stringify(cache))
  }
  // 清除整个缓存
  const clearUnReadGroupCache = () => {
    try {
      sessionStorage.removeItem('UNREAD_GROUP_CACHE')
    } catch (error) {
      console.error('Error clearing cache:', error)
    }
  }
  // 清除缓存中 groups 数组中的指定 groupId
  const clearGroupIdFromCache = groupId => {
    try {
      const cache = getCacheData() // 获取缓存数据
      if (!cache) return
      // 过滤掉 groupIds 中的指定 groupId
      const updatedGroupIds = cache?.groups?.filter(item => item.groupId !== groupId) || []
      // 更新缓存
      setCacheData(cache.time, updatedGroupIds)
    } catch (error) {
      console.error('Error clearing groupId from cache:', error)
    }
  }
  // 完成工单判断是否存在混存的未读消息群组数据
  const finishPrecheck = async params => {
    try {
      // 获取缓存数据
      const cache = getCacheData()
      const currentTime = Date.now()
      // 判断是否五分钟内调用过，避免重复请求
      if (cache?.time && currentTime - cache?.time < 5 * 60 * 1000) {
        // 如果 groups 存在且有值，弹出提示
        if (cache?.groups?.length > 0) {
          showWarning(cache?.groups)
          return false // 已有未处理的工单，返回 false
        }
        return true // 没有未读消息，可以继续操作
      }
      // 发起请求，获取最新的未读消息群组数据
      const result = await getFinishPrecheck(params)
      const { groups = [] } = result || {}
      // 更新缓存
      setCacheData(currentTime, groups)
      // 如果 groups 有值，弹出提示并返回 false
      if (groups?.length > 0) {
        showWarning(groups)
        return false
      }
      // 没有未读消息，可以继续操作
      return true
    } catch (error) {
      return false
    }
  }

  return {
    defineUnReadNum,
    unReadNum,
    allGroupMsgList,
    handleAckReadStatus,
    hadnleReadRoles,
    computedUnRead,
    finishPrecheck,
    clearGroupIdFromCache,
    clearUnReadGroupCache
  }
}
